<form id="informations-client-form" class="px-4" [formGroup]="terrainForm">
  <div class="d-flex justify-content-between mb-5">
    <div class="col-4">
      <p-input
        [formControl]="terrainForm.controls.propertyType"
        id="propertyType"
        name="propertyType"
        label="Type de bien"
        [disabled]="true"
      ></p-input>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="terrainForm.controls.areaM2"
        id="areaM2"
        name="areaM2"
        label="Surface"
        placeholder="Ex : 100"
        fixedText="m²"
        type="number"
        (input)="onAreaM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="terrainForm.controls.facadeWidthM2"
        id="facadeWidthM2"
        name="facadeWidthM2"
        label="Largeur de façade"
        placeholder="Ex : 100"
        fixedText="m²"
        (input)="onFacadeWidthM2Changed($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-select
        id="viability"
        [items]="viabilityTypeItems"
        [selectedItem]="viabilityItem"
        label="Viabilité"
        (selected)="onViabilitySelected($event)"
      ></p-select>
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-4">
      <p-input
        [formControl]="terrainForm.controls.plotRatio"
        id="plotRatio"
        name="plotRatio"
        label="COS"
        placeholder="Ex : 100"
        type="number"
        (input)="onPlotRatioChanged($event)"
      ></p-input>
    </div>
    <div class="col-4">
      <p-input
        [formControl]="terrainForm.controls.accessibility"
        id="accessibility"
        name="accessibility"
        label="Accessibilité"
        placeholder="Ex : Très bonne"
        (input)="onAccessibilityChanged($event)"
      ></p-input>
    </div>
  </div>
</form>
